import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';

class Banner extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Learn From Expert in details',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: '16 Chapters included',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Hardcover and PDF  versions',
                },
                /*{
                    id: 4,
                    icon: 'fa fa-check',
                    title: 'Audio book with every purchase',
                },*/
            ]
        };
    }

    gtag_report_conversion = (event, url = null) => {
        if (typeof window.gtag !== "function") {
            console.error("Google Ads is not loaded properly.");
            return;
        }

        window.gtag('event', 'conversion', {
            'send_to': 'AW-16832649503/oq0QCPbF0ZYaEJ-yt9o-'
        });

        console.log("Conversion event sent:", event.target);

        if (url) {
            setTimeout(() => {
                window.location.href = url;
            }, 500);
        }
    };

    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content ">
                                <span className="subheading">Exclusive Offer: 5% discount on early purchase</span>
                                <h1>Master Adaptive Control with Neural Networks, One Step at a Time</h1>
                                <ul>
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                <HashLink to="#contact" className="btn btn-main" onClick={(event) => this.gtag_report_conversion(event)}>Pre-order on Amazon Now</HashLink>  
                                <p>Interested in free chapter? <HashLink to="#contact" smooth onClick={(event) => this.gtag_report_conversion(event)}>Get it now</HashLink></p>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="banner-img">
                                <img src="assets/images/banner/book.png" alt="" className="img-fluid"/>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>

        );
    }
}

export default Banner;

